import { render, staticRenderFns } from "./DocumentActions.vue?vue&type=template&id=11684c91&scoped=true&"
import script from "./DocumentActions.vue?vue&type=script&lang=js&"
export * from "./DocumentActions.vue?vue&type=script&lang=js&"
import style0 from "./DocumentActions.vue?vue&type=style&index=0&id=11684c91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11684c91",
  null
  
)

export default component.exports